import { useEffect } from "react";
import { BudgetDTO } from "../../../dto/budget/BudgetDTO";
import { ComboDataDTO } from "../../../dto/ComboDataDTO";
import { getBillingEntities } from "../../../servicesHooks/BillHospitalization/useBillHospitalizationService";

/**
 * La factura guardada trae la entidad facturadora sin su nombre: se busca el nombre para mostrarla en el combo.
 * `onName` recibe el nombre solo si la entidad sigue siendo la misma cuando llega la respuesta.
 */
export function useBillingEntityName(billingEntity: number | null | undefined, billingEntityName: string | null | undefined,
    onName: (name: string) => void) {
    useEffect(() => {
        if (!billingEntity || billingEntity <= 0 || billingEntityName) return;
        let cancelled = false;
        getBillingEntities({ filterValue: '', offSet: 0, pageSize: 200 })
            .then((entities: ComboDataDTO[]) => {
                const saved = (entities ?? []).find(entity => entity.id === billingEntity);
                if (!cancelled && saved?.name) onName(saved.name);
            })
            .catch(() => undefined);
        return () => { cancelled = true; };
        // onName se arma en cada render: solo importa la entidad
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [billingEntity, billingEntityName]);
}

/**
 * Lo que había al abrir, para saber si hubo cambios al salir. El nombre de la entidad que se completa al abrir no es un
 * cambio; tampoco la entidad que se elige sola cuando no había ninguna y hay una sola para elegir.
 */
export function baselineWithAutoBillingEntity(initial: BudgetDTO, current: BudgetDTO): BudgetDTO {
    if (initial.billingentity > 0) {
        return {
            ...initial,
            billingentitydesc: initial.billingentity === current.billingentity ? current.billingentitydesc : initial.billingentitydesc,
        };
    }
    return { ...initial, billingentity: current.billingentity, billingentitydesc: current.billingentitydesc };
}
